export default "__VITE_ASSET__aUwcDPuP__"